/**
 * Same {error:[{field,messages}]} shape as the other settings pages
 * (AppExceptionRenderer.php) — see OrganizationMembersPage/errorHelpers.js.
 */
export function parseGeneralError(error, fallback) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];
  const messages = entries.flatMap((entry) => entry.messages || []);

  if (messages.length) {
    return messages.join(" ");
  }

  return data?.message || error?.message || fallback;
}
